<template>
  <div>
    <div class="loading" v-if="$store.state.isLoading">
      <div class="loading-mask"></div>
      <div class="loading-content" role="status">
        <Spin class="loading-icon" size="large" />
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { Spin } from "ant-design-vue";

export default {
  components: {
    Spin,
  },
};
</script>

<style>
.ant-layout-sider-trigger {
  display: none;
}
</style>

<style lang="scss">
.loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999999;

  .loading-mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
  }

  .loading-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 2;
    display: flex;

    .loading-icon {
      margin: auto;
    }
  }
}
</style>
